// Audit API — typed-обёртка для /api/audit-events (admin only).

import { apiClient } from './client';

/** DTO события аудита (backend AuditEventDto: username отсутствует — только userId). */
export interface AuditEvent {
  id: string;
  eventType: string;
  entityType: string;
  entityId: string;
  userId: string;
  ipAddress: string | null;
  userAgent: string | null;
  details: Record<string, unknown> | null;
  createdAt: string;
}

export interface AuditEventFilters {
  page?: number;
  size?: number;
  userId?: string;
  eventType?: string;
}

/** Audit API (admin only). */
export const auditApi = {
  /** GET /api/audit-events?filters → Page<AuditEvent>. */
  async list(filters: AuditEventFilters = {}): Promise<{
    content: AuditEvent[];
    total: number;
    page: number;
    size: number;
  }> {
    const { data } = await apiClient.get<{
      content: AuditEvent[];
      total: number;
      page: number;
      size: number;
    }>('/api/audit-events', { params: filters });
    return data;
  },
};
